module.exports = __webpack_public_path__ + "img/GettyImages-771616379-5af9cda5ba61770036390145.7225ff3b.jpg";